import { render, staticRenderFns } from "./GstWithHoldingStatementModal.vue?vue&type=template&id=2ab9ab80&scoped=true"
import script from "./GstWithHoldingStatementModal.vue?vue&type=script&lang=js"
export * from "./GstWithHoldingStatementModal.vue?vue&type=script&lang=js"
import style0 from "./GstWithHoldingStatementModal.vue?vue&type=style&index=0&id=2ab9ab80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab9ab80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab9ab80')) {
      api.createRecord('2ab9ab80', component.options)
    } else {
      api.reload('2ab9ab80', component.options)
    }
    module.hot.accept("./GstWithHoldingStatementModal.vue?vue&type=template&id=2ab9ab80&scoped=true", function () {
      api.rerender('2ab9ab80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gstreport/GstWithHoldingStatementModal.vue"
export default component.exports